import {Role} from "types/global";

export const DEBOUNCE_DELAY: number = 500;
export const DEFAULT_PAGE_LIMIT: number = 10;

export const ROLE_SUPER_ADMIN = "super-admin";
export const ROLE_ADMIN = "admin";
export const ROLE_MANAGER = "manager";
export const ROLE_MODERATOR = "moderator";
export const ROLE_AGENT = "agent";
export const ROLE_USER = "user";

export const ORDERED_ROLE_LIST: Role[] = [
  ROLE_USER,
  ROLE_AGENT,
  ROLE_MODERATOR,
  ROLE_MANAGER,
  ROLE_ADMIN,
  ROLE_SUPER_ADMIN,
];

export const ENGLISH_LANGUAGE = "en";

export const CALL_STATUS_PENDING = "pending";
export const CALL_STATUS_SUCCESSFUL = "successful";
export const CALL_STATUS_UNANSWERED = "unanswered";
export const CALL_STATUS_UNAVAILABLE = "unavailable";
export const CALL_STATUS_CALLBACK = "callback";

export const CALL_STATUS = [
  CALL_STATUS_PENDING,
  CALL_STATUS_SUCCESSFUL,
  CALL_STATUS_UNANSWERED,
  CALL_STATUS_UNAVAILABLE,
  CALL_STATUS_CALLBACK,
] as const;

export type CallStatus = (typeof CALL_STATUS)[number];

export const NUMBER_FORMAT_MONEY = "money";
export const NUMBER_FORMAT_NUMBER = "number";

export const COMPARE_BY_COUNTRY = "country";
export const COMPARE_BY_GAME = "game";

export const AGG_COUNT = "count";
export const AGG_SUM = "sum";
export const AGG_MIN = "min";
export const AGG_MAX = "max";
export const AGG_AVG = "avg";

export const TIME_GROUP_DAY = "day";
export const TIME_GROUP_WEEK = "week";
export const TIME_GROUP_MONTH = "month";
export const TIME_GROUP_YEAR = "year";

export const BONUS_STATUS_ACTIVE = "active";
export const BONUS_STATUS_EXPIRED = "expired";
export const BONUS_STATUS_REDEEMED = "redeemed";

export const STATUS_CLOSED = "closed";
export const STATUS_OPEN = "open";
export const STATUS_CANCELLED = "cancelled";
export const STATUS_SETTLED = "settled";

export const TRANSACTION_DEPOSITS = "deposit";
export const TRANSACTION_WITHDRAWALS = "withdrawal";
export const TRANSACTION_REFERRALS = "referral";

export const WALLET_TYPE_FREEBET = "freebie";

export const REG_STATUS_ACTIVE = "active";
export const REG_STATUS_DEACTIVATED = "deactivated";
export const REG_STATUS_TERMINATED = "terminated";

export const SORT_ASC = "asc";
export const SORT_DESC = "desc";
